var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepresentative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "distribuot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.118,
    height: 38.966,
    viewBox: "0 0 39.118 38.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17524",
    "data-name": "Path 17524",
    d: "M24.776,26.635c.206-1.234.617-2.262.822-3.5a4.008,4.008,0,0,0-.206-1.645c-.617-1.234-.617-2.056.411-2.673a2.213,2.213,0,0,1,2.878.617,1.294,1.294,0,0,1,0,1.234,5.106,5.106,0,0,0,0,5.14c0,.206.206.411.411.822.206-.617.411-1.028.617-1.645s.411-1.028.617-1.645c.617-1.439,1.234-2.878,1.85-4.523a.862.862,0,0,1,1.234-.617,1.559,1.559,0,0,1,.822.411,19.976,19.976,0,0,1,7.4,10.075c.617,2.262.206,3.084-2.056,3.907a28.831,28.831,0,0,1-8.224,1.439,59.921,59.921,0,0,1-13.57-.206A56.36,56.36,0,0,1,12.028,32.8,1.37,1.37,0,0,1,11,31.364c.206-6.579,3.7-11.308,9.869-13.364,1.028,2.673,2.262,5.346,3.29,8.224C24.57,26.635,24.776,26.635,24.776,26.635Z",
    transform: "translate(-2.776 4.643)",
    fill: "#005795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17525",
    "data-name": "Path 17525",
    d: "M15.272,17.5C14.45,12.77,17.328,7.219,22.88,7.013a9.189,9.189,0,0,1,7.4,2.878c2.056,2.262,2.262,4.935,2.056,7.813a.958.958,0,0,1,1.234,1.028A5.216,5.216,0,0,1,33.16,21.2a24.392,24.392,0,0,1-7.4,7.813,2.811,2.811,0,0,1-3.7-.206c-1.439-1.234-2.878-2.673-4.318-4.112-1.234-1.234-2.056-2.467-3.29-3.7a3.238,3.238,0,0,1-.822-2.673C14.039,17.294,14.244,17.088,15.272,17.5Z",
    transform: "translate(-0.057 -6.987)",
    fill: "#005795"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17526",
    "data-name": "Path 17526",
    d: "M13.579,38.273H7V15.656c0-1.645.411-2.056,2.056-2.056H19.542c1.439,0,1.85.411,1.85,1.645.206,2.056.206,4.112.411,5.963a1.243,1.243,0,0,1-.617,1.234A21.9,21.9,0,0,0,15.43,28.2a12.391,12.391,0,0,0-2.056,8.841v.617A.755.755,0,0,1,13.579,38.273Zm-2.673-18.71H17.9V18.123H10.907ZM17.9,20.591H10.907v1.234H17.9Q17.9,21.207,17.9,20.591Z",
    transform: "translate(-7 -0.004)",
    fill: "#005795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepresentative);
export default __webpack_public_path__ + "static/media/Representative.d93e982d7a115d13a64b1c75a1d2fd06.svg";
export { ForwardRef as ReactComponent };